import { isAcquiringTrade } from './AcquiringField.js';
export const getPartnerComments = (data) => {
    const { acquiringType, onlineCheckout = false, posTerminal = false, term, amount, annualRevenue, } = data;
    if (acquiringType) {
        return `Вид эквайринга=${acquiringType?.text || ''}${isAcquiringTrade(acquiringType?.key)
            ? `/Онлайн касса=${onlineCheckout}/POS-терминал=${posTerminal}`
            : '/Онлайн касса=false/POS-терминал=false'}`;
    }
    else {
        return `Сумма=${amount}/Срок=${term}/Выручка=${annualRevenue}`;
    }
};
//# sourceMappingURL=getPartnerComments.js.map